<template lang="pug">
  .flex.w-full.md-px-100.flex-wrap.justify-between(v-if="doc && doc.acf.artworks")
    //- artworks
    figure.w-full.md-w-5x12.mb-120(v-for="(work, i) in doc.acf.artworks")
      carousel(:images="work.images", style="padding-bottom:90%", :noBgCover="true", :noCaptions="true")
      figcaption.px-15.mt-30.md-px-0
        .text-11.md-text-13(v-html="work.text")
        .mt-30.flex.justify-center
          button(@click="enquire = i")
            btn.min-w-btn Enquire
    //- enquire overlay
    transition(name="fade")
      enquire.fixed.z-50.inset-0(v-if="enquiry", :details="enquiry", @close="enquire = -1")
</template>

<script>
import Carousel from '@/components/Carousel/Carousel'
import Btn from '@/components/Btn'
import _get from 'lodash/get'
import Enquire from '@/components/Enquire'
export default {
  name: 'Artworks',
  props: ['doc'],
  data () {
    return {
      enquire: -1
    }
  },
  computed: {
    enquiry () {
      const work = _get(this.doc, `acf.artworks[${this.enquire}]`)
      return work && {
        ref: work.reference,
        postId: this.doc.id,
        thumb: work.images[0].sizes.medium,
        caption: work.text,
        image: work.images[0]
      }
    }
  },
  components: { Carousel, Btn, Enquire }
}
</script>

<style>
</style>
